import {
  Container,
  DescriptionTopHeader,
  DivHeaderBtn,
  DivTitleTopHeader,
  ImgHeaderBtn,
  SvgHeaderBtn,
  TitleTopHeader,
  TopHeader,
} from "./HeaderAddElements";
import back from "../../Images/headerIcons/back.svg";
import defualtLogo from "../../Images/defaultImage/deliveryCompany.svg";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Header = ({ description, page, logo }) => {
  const navigate = useNavigate();
  useEffect(() => {}, []);

  return (
    <>
      <Container>
        <TopHeader>
          <DivHeaderBtn onClick={() => navigate(-1)}>
            <ImgHeaderBtn src={back} />
          </DivHeaderBtn>
          <DivTitleTopHeader>
            <TitleTopHeader>ثبت آدرس</TitleTopHeader>
            <DescriptionTopHeader>{description}</DescriptionTopHeader>
          </DivTitleTopHeader>
          <DivHeaderBtn hide></DivHeaderBtn>
        </TopHeader>
      </Container>
    </>
  );
};

export default Header;
